import { render, staticRenderFns } from "./ProductCategoryGrid.vue?vue&type=template&id=b201053c"
import script from "./ProductCategoryGrid.vue?vue&type=script&lang=js"
export * from "./ProductCategoryGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports